import React from 'react';
import PageMeta from '../components/PageMeta';
import Header from '../components/Header';
import Hero from '../components/Hero';
import SearchBar from '../components/SearchBar';
import FeaturedProducts from '../components/FeaturedProducts';
import Services from '../components/Services';
import CTA from '../components/CTA';
import Footer from '../components/Footer';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      <PageMeta
        title="Home"
        description="FM Ultratech Farms – Your partner in modern farming solutions. Quality greenhouse products, smart agriculture services, and expert support for farmers in Nigeria."
      />
      <Header />
      <Hero />
      <SearchBar />
      <FeaturedProducts />
      <Services />
      <CTA />
      <Footer />
    </div>
  );
};

export default Home;
